<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "heatmap-location",
  props: ["item", "series", "height"],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      chartOptions: {
        chart: {
          width: "100%",
          type: "heatmap",
          offSetX: 10000
        },
        xaxis: {
          position: "top",
          labels: {
            formatter: function (seriesName) {
              return seriesName + " vs last year ";
            }
          }
        },
        yaxis: {
          show: true,
          labels: {
            show: true,
            formatter: function (value) {
              function titleCase(str) {
                return str.split("-");
              }
              if (value == undefined || value ==  null || value == ''){
                return 0
              }
              if (value) {
                if (typeof value === "string") {
                  return titleCase(value);
                }else{
                  return Math.round( value * 100)/100
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return Math.round(`${val}` * 100)/100 + '%';

          }
        },
        plotOptions: {
          heatmap: {
            reverseNegativeShade: false,
            shadeIntensity: 0.5,
            radius: 10,
            enableShades: true,
            useFillColorAsStroke: false,
            colorScale: {
              ranges: [
                {
                  from: -999999999,
                  to: 0,
                  color: "#e31b23"
                },
                {
                  from: 1,
                  to: 999999999,
                  color: "#00853f"
                },
                {
                  from: 0,
                  to: 0.9,
                  color: "#cccccc"
                }
              ]
            }
          }
        },
        legend: {
          show: false
        },
        // tooltip: {
        //   custom: function({series, seriesIndex, dataPointIndex, w}) {
        //     return '<div class="arrow_box">' +
        //       '<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
        //       '</div>'
        //   }
        // }
      }
    };
  }
};
</script>
<template>
  <div>
    <apexchart
        type="heatmap"
        :height="height"
        :options="chartOptions"
        :series="series"
    ></apexchart>
  </div>
</template>
